import $ from 'jquery';
import Parallax from '@nodeModules/parallax-js';
import select2 from 'select2';

var tabletWide = 959,
    tablet = 768,
    mobile = 479;

function getScrollBarWidth() {
  var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
  widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
  $outer.remove();
  return 100 - widthWithScroll;
};

function newsletterAnimation() {
  if ($('.js-GlassesWrapper').get(0)) {
    new Parallax($('.js-GlassesWrapper').get(0), {
      invertX: false,
      invertY: false
    });
  }
}

window.mapSelect2 = function() {
  $('.select2Dropdown').each(function() {
    $(this).select2({
      dropdownParent: $(this).parent()
    });
  });
}

function scrollToTop() {
  $("a[href='#top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });
}

function eventCountdown() {
  if($('.js-event-countdown').length) {
    // Event date specified in single event page
    var finalDate = $('.js-event-countdown').data('countdown');
    $('.js-event-countdown').countdown(finalDate, function(event) {
      var $this = $(this).html(event.strftime(
        `
          <dl>
            <dt>%D</dt>
            <dd>d</dd>
          </dl>
          <dl>
            <dt>%H</dt>
            <dd>h</dd>
          </dl>
          <dl>
            <dt>%M</dt>
            <dd>min</dd>
          </dl>
        `
      ));
    });
  }

  if($('.js-StreamCountdown').length) {
    // Event date specified in single event page
    var finalDate = $('.js-StreamCountdown').data('countdown');

    $('.js-StreamCountdown').countdown(finalDate, function(event) {
      $(this).html(event.strftime(''
          + '<dl>'
          + '<dt>%D</dt>'
          + '<dd>d</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%H</dt>'
          + '<dd>h</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%M</dt>'
          + '<dd>min</dd>'
          + '</dl>'
      ));
      + '</dl>'

    });

    $('.js-StreamCountdown').countdown(finalDate).on('finish.countdown', function(event) {
      var url = $('.js-StreamCountdown').data('url');
      setTimeout(function(){
        document.location.reload();
      }, 1000);
    });
  }

  if($('.js-StreamCountdownOverlay').length) {
    // Event date specified in single event page
    var finalDate = $('.js-StreamCountdownOverlay').data('countdown');

    $('.js-StreamCountdownOverlay').countdown(finalDate, function(event) {
      $(this).html(event.strftime(''
          + '<dl>'
          + '<dt>%D</dt>'
          + '<dd>d</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%H</dt>'
          + '<dd>h</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%M</dt>'
          + '<dd>min</dd>'
          + '</dl>'
      ));
      + '</dl>'

    });
  }

  if($('.js-StreamCountdownOverlaySeconds').length) {
    // Event date specified in single event page
    var finalDate = $('.js-StreamCountdownOverlaySeconds').data('countdown');

    $('.js-StreamCountdownOverlaySeconds').countdown(finalDate, function(event) {
      $(this).html(event.strftime(''
          + '<dl>'
          + '<dt>%D</dt>'
          + '<dd>d</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%H</dt>'
          + '<dd>h</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%M</dt>'
          + '<dd>min</dd>'
          + '</dl>'

          + '<dl>'
          + '<dt>%S</dt>'
          + '<dd>sec</dd>'
          + '</dl>'
      ));
      + '</dl>'

    });
  }

  if($('.js-checkout-countdown').length) {
    function addZero(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    }

    function formatCountdownDate(date) {
      return addZero(date.getFullYear()) + '/' + addZero(date.getMonth()+1) + '/' + addZero(date.getDate())
        + ' ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes()) + ':' + addZero(date.getSeconds());
    }

    // Event date specified in single event page
    let minuteOffset = $('.js-checkout-countdown').data('minutes');

    if(minuteOffset === undefined || minuteOffset === '') {
      minuteOffset = 30;
    }

    var today = new Date();
    today.setMinutes(today.getMinutes() + minuteOffset);

    var finalDate = formatCountdownDate(today);

    $('.js-checkout-countdown').countdown(finalDate, function(event) {
      var $this = $(this).html(event.strftime(''
      + '<dl>'
        + '<dt>%M</dt>'
      + '</dl>'
      + '<dl>'
        + '<dt>%S</dt>'));
      + '</dl>'
    }).on('finish.countdown', function(event) {
      $(".js-checkout-submit").hide();
      $(".js-checkout-submit").after("<span class='checkout-total__timeout-msg'>" + eventTimeoutMessage + "</span>");


      alert(timeoutPopUp);
      if (document.referrer !== "") {
          document.location.reload(true);
      }
    });

    // The checkout page loads two webpack bundles, each with its own jQuery instance and therefore its
    // own countdown registry, so the page-checkout bundle cannot reach the widget created above. It
    // calls this instead. Takes seconds remaining rather than a server timestamp, because the widget
    // counts down against the browser's clock and a timestamp would carry that clock's skew.
    window.reseedCheckoutCountdown = function (secondsRemaining) {
      if (!(secondsRemaining > 0)) {
        return;
      }

      var newFinalDate = new Date(new Date().getTime() + (secondsRemaining * 1000));

      $('.js-checkout-countdown').countdown(formatCountdownDate(newFinalDate));
    };
  }
}

function checkAll() {
  $('.js-CheckAll').change(function() {
    // Select/deselect all
    if ($('.js-CheckAll').prop('checked') === true) {
      $('.js-CheckboxContainer input[type="checkbox"]').prop('checked', true);
    } else {
      $('.js-CheckboxContainer input[type="checkbox"]').prop('checked', false);
    }

    // Deselect main controller if sub contollers clicked
    $('.js-CheckboxContainer input[type="checkbox"]').change(function() {
      $('.js-CheckAll').prop('checked', false);
    });
  });
}

// Document ready
$(document).ready(function() {
  // Functions
  checkAll(); // Check all checkboxes on click
  eventCountdown(); // Event and payments countdown
  scrollToTop(); // Footer scroll to top
  newsletterAnimation(); // Show newsletter glasses animation and toggle success message on send
  isIE();
  if (window.infoBar) {
    window.infoBar();
  }

  if ($('.select2-select').length) {
    $('.select2-select').each(function() {
      $(this).select2({
        dropdownParent: $(this).parent()
      });
    });
  }

  if ($('.select2Dropdown').length) {
    $('.select2Dropdown').each(function() {
      $(this).select2({
        dropdownParent: $(this).parent()
      });
    });
  }
});

function isIE() {
    if(navigator.userAgent.indexOf('MSIE')!==-1
        || navigator.appVersion.indexOf('Trident/') > 0){
        $(".ie-message").addClass("ie-message--active");
    }
}

function checkTimezonePopup() {
  if (typeof UserTimezone === "undefined") {
    return true;
  }

  let currentTime = moment();
  //let currentTimezoneOffset = currentTime.utcOffset();
  let currentTimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if ((typeof UserTimezone !== "undefined" || UserTimezone !== undefined)) {
    if (typeof UserTimezone !== "undefined" && UserTimezone === false) {
      //UserTimezone = currentTimezoneOffset;
      UserTimezone = currentTimezoneName;
    }
  }

  let showPopup = false;
  if (typeof UserTimezone !== "undefined") {
    if (typeof UserTimezone !== "undefined" && UserTimezone !== false && (currentTimezoneName != UserTimezone)) {//currentTimezoneOffset
      showPopup = true;
    }
  }

  if (typeof UserTimezone === "undefined") {
    return true;
  }

  return showPopup;
}

let setupTimezoneList = function(){
  const guessTimezone = moment.tz.guess();

  document.querySelector(".js-timezone-select").innerHTML = moment.tz.names()
      .reduce((memo, tz) => {
        memo.push({
          name: tz,
          offset: moment.tz(tz).utcOffset()
        });

        return memo;
      }, [])
      .sort((a, b) => {
        return a.offset - b.offset
      })
      .reduce((memo, tz) => {
        const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';
        let selected = '';
        if(guessTimezone === tz.name){
          selected = 'selected'
        }
        return memo.concat(`<option data-timezone-name="${tz.name.replace(/_/g, '\n')}" value="${tz.offset}" ${selected}>(GMT${timezone}) ${tz.name.replace(/_/g, '\n')}</option>`);
      }, "");
}

const openTimezoneAlert = function(e) {
    setupTimezoneList();
    window.entrio.showModal("#timezone_popup_alert");

    $("#saveTimezoneSettings").on("click", function (e) {
        $.ajax({
            url: siteUrl + "ajax/saveTimeZone",
            type: "POST",
            data: {
                timezoneOffset: $('#timezone_value').val(),
                timezoneName: $("#timezone_value option:selected").data("timezone-name"),
            },
        }).done(function (data) {
            data = JSON.parse(data);
            makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
            window.location.reload();
        }).fail(function () {
            makeInfoBar("Error", 'error', 500, 8000);
        });
    });
}

function elastic_log_v2(message = 'frontend_log', data = {}) {
    setTimeout(function () {
        $.ajax({
            url: siteUrl + 'ajax/elastic_log',
            data: {
                "message" : message,
                "data": data
            },
            dataType: 'json',
            type: 'post',
            success: function (data) {
                console.log('error logged');
            }
        })
    }, 200);
};

$(window).on('load', function(event) {
  let showTimezonePopup = checkTimezonePopup();

  if(showTimezonePopup){
    let currentTimezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    elastic_log_v2('checkTimezonePopup is true',
        {
          userId : typeof userId !== 'undefined' ? userId : 'N/A',
          UserTimezone : typeof UserTimezone !== "undefined" ? UserTimezone : 'N/A',
          currentTimezoneName : currentTimezoneName,
        }
    );
    //openTimezoneAlert(event); //nakon što saznamo zašto puca nekim ljudima treba maknuti ovu liniju
  }
});
